import React from 'react';
import PropTypes from 'prop-types';
import { Table, Checkbox } from 'semantic-ui-react';
import SearchTableData from '../util/SearchTableData';

const SEARCH_FIELDS = ['firstName', 'lastName', 'indexNumber', 'studyCycleName', 'studyProgramName', 'studyYear'];
const COLUMN_SPAN = 10;

class StudentAccessDataTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            results: [],
        };

        this.onSelectRow = this.onSelectRow.bind(this);
        this.getResults = this.getResults.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
    }

    onSelectRow(id) {
        const row = this.props.data.find(el => el.id === id);
        this.props.onDataChange(row);
    }

    getResults(results) {
        this.setState({ results });
    }

    getDataToRender() {
        return this.state.results.length !== 0 ? this.state.results : this.props.data;
    }

    isRowSelected(rowId) {
        return this.props.selectedData.findIndex(e => e.id === rowId) > -1;
    }

    isAllSelected() {
        const { selectedData, data } = this.props;
        return selectedData.length === data.length && data.length > 0;
    }

    render() {
        const { data, selectAll } = this.props;
        const dataToRender = this.getDataToRender();

        return (
            <React.Fragment>
                <Table selectable celled>
                    <Table.Header>
                        <Table.HeaderCell colSpan={COLUMN_SPAN}>
                            <SearchTableData
                                profMozilla
                                data={data}
                                getResults={this.getResults}
                                filterItem={SEARCH_FIELDS}
                            />
                        </Table.HeaderCell>

                        <Table.Row>
                            <Table.HeaderCell textAlign="center">
                                <Checkbox
                                    type="checkbox"
                                    name="checkAllButton"
                                    onChange={selectAll}
                                    checked={this.isAllSelected()}
                                />
                            </Table.HeaderCell>
                            <Table.HeaderCell verticalAlign="middle" colSpan={2}>
                                Prezime i ime studenta/ice
                            </Table.HeaderCell>
                            <Table.HeaderCell verticalAlign="middle" colSpan={1}>
                                Index
                            </Table.HeaderCell>
                            <Table.HeaderCell verticalAlign="middle" colSpan={2}>
                                Ciklus studija
                            </Table.HeaderCell>
                            <Table.HeaderCell verticalAlign="middle" colSpan={2}>
                                Studijski program
                            </Table.HeaderCell>
                            <Table.HeaderCell verticalAlign="middle" colSpan={2}>
                                Godina studija
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {dataToRender.length > 0 ? (
                            dataToRender.map(row => (
                                <Table.Row
                                    onClick={() => this.onSelectRow(row.id)}
                                    key={row.id}
                                    className={this.isRowSelected(row.id) ? 'table-active' : ''}
                                >
                                    <Table.Cell textAlign="center">
                                        <Checkbox
                                            name={row.id}
                                            type="checkbox"
                                            checked={this.isRowSelected(row.id)}
                                        />
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" colSpan={2}>
                                        {row.lastName} {row.firstName}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" colSpan={1}>{row.indexNumber}</Table.Cell>
                                    <Table.Cell verticalAlign="middle" colSpan={2}>{row.studyCycleName}</Table.Cell>
                                    <Table.Cell verticalAlign="middle" colSpan={2}>{row.studyProgramName}</Table.Cell>
                                    <Table.Cell verticalAlign="middle" colSpan={2}>{row.studyYear}</Table.Cell>
                                </Table.Row>
                            ))
                        ) : (
                            <Table.Row>
                                <Table.Cell colSpan={COLUMN_SPAN} textAlign="center">
                                    Nema studenata za prikaz
                                </Table.Cell>
                            </Table.Row>
                        )}
                    </Table.Body>
                </Table>
            </React.Fragment>
        );
    }
}

StudentAccessDataTable.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object).isRequired,
    selectedData: PropTypes.arrayOf(PropTypes.object).isRequired,
    onDataChange: PropTypes.func.isRequired,
    selectAll: PropTypes.func.isRequired
};

export default StudentAccessDataTable;



// WEBPACK FOOTER //
// ./src/views/GenerateUsers/StudentAccessDataTable.js